import { CrudService } from './crud.service';
export class ProductStyleExceptionService {
  constructor(private crudService = new CrudService<any>('')) {}

  public async uploadFile(season: string, exceptionType: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('season', season);
    formData.append('exceptionType', String(exceptionType));

    return await this.crudService.downloadFile('api/assortments/exceptions/import', formData, '', {
      responseType: 'blob',
    });
  }
}
